import {createDirectus, rest, authentication, AuthenticationData, AuthenticationStorage, graphql} from "@directus/sdk";
import { environment } from "./src/environments/environment";

type Global = {
  slug: string;
  title: string;
  description: string;
}

type Author = {
  slug: string;
  name: string;
}

type Page = {
  slug: string;
  title: string;
  content: string;
}

type Post = {
  slug: string;
  image: string;
  title: string;
  content: string;
  author: Author;
  published_date: string;
}
type Progetto = {
  id: number;
  status: string;
  nome: string;
  descrizione: string;
  website: string;
  tipologia: number;
  immagine: any;
  colore: string
}

type Edizione = {
  id: number;
  status: number;
  nome: string;
  descrizione: string;
  inizio: Date;
  fine: Date;
  progetto: number;
  badge: string;
  b_font_size: number;
  bw: number;
  bh: number;
  tx: number;
  ty: number;
  qrcode_w: number;
  qrcode_h: number;
  qrcode_x: number;
  qrcode_y: number;
}
type Iscrizione = {
  id: number;
  status: number;
  date_created: Date;
  date_updated: Date;
  nome: string;
  cognome: string;
  azienda: string;
  email: string;
  profilo: string;
  edizione: number;
  confermata: number;
  presenza: number;
  orario: string;
}
type User = {
  id:string;
  first_name:string;
  last_name:string;
  email:string;
  password:string;
  location: string,
  title:string;
  description:string;
  tags:string;
  avatar:string;
  language:string;
  appearance:string;
  tfa_secret:string;
  status:string;
  role:string;
  token:string;
  last_access:string;
  last_page:string;
}

type Schema = {
  global: Global;
  posts: Post[];
  pages: Page[];
  image: any,
  progetti: Progetto[];
  edizione: Edizione[];
  iscrizioni: Iscrizione[];
  user: User;
}
export const authLocalStorage = (mainKey: string = "directus_storage") => ({
  // implementation of get, here return json parsed data from localStorage at mainKey (or null if not found)
  get: async () => {
      const data = window.localStorage.getItem(mainKey);
      if (data) {
        return JSON.parse(data);
      }
      return null;
    },
  // implementation of set, here set the value at mainKey in localStorage, or remove it if value is null
  set: async (value: AuthenticationData | null) => {
      if (!value) {
        return window.localStorage.removeItem(mainKey);
      }
      return window.localStorage.setItem(mainKey, JSON.stringify(value));
    },
} as AuthenticationStorage);

//const directus = createDirectus<Schema>(environment.apiUrl).with(authentication())
//  .with(rest({ credentials: "include" }));
////const directus = createDirectus<Schema>(environment.apiUrl).with(authentication("cookie", { credentials: "include", autoRefresh: true }))
//  .with(rest({ credentials: "include" }));
//const directus = createDirectus<Schema>(environment.apiUrl).with(authentication("cookie", {credentials: "include", autoRefresh: true, msRefreshBeforeExpires: 5000}))
//  .with(rest({credentials: "include"}));
const directus =
  createDirectus<Schema>(environment.apiUrl).with(authentication('json', { // add this if you want to use authentication, json is important, it's type of your authentication usage, here JWT
    storage: authLocalStorage(), // here set the storage previously created
  })).with(rest()).with(graphql());

export { directus, Global, Post, Page, Progetto, Edizione, Iscrizione, User }

